import FalconCardHeader from 'components/common/FalconCardHeader';
import React from 'react';
import { Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { updateJournalFingerPrintAction } from 'stores/app';

const JournalSettings = () => {
  const { updatingJournalFingerPrintMode, userMaster } = useSelector(
    state => state.app
  );
  const dispatch = useDispatch();

  const updateJournalFingerPrintMode = journalFingerPrintMode => {
    let updatedUserMaster = Object.assign({}, userMaster);
    updatedUserMaster.FingerprintCollectionEnabled = journalFingerPrintMode;
    dispatch(
      updateJournalFingerPrintAction(userMaster?.GUID, updatedUserMaster)
    );
  };

  return (
    <Card className="mb-3">
      <FalconCardHeader title="Journal Settings" />
      <Card.Body className="bg-light">
        <div className="ps-2">
          <Row>
            <Col className="d-flex" lg={12}>
              <Form.Check
                type="switch"
                id="custom-switch-journal-fingerprint-mode"
                label="Enable Fingerprint Collection (Optional)"
                className="form-label-nogutter"
                name="numberVisibility"
                onChange={() =>
                  updateJournalFingerPrintMode(
                    !userMaster?.FingerprintCollectionEnabled
                  )
                }
                checked={userMaster?.FingerprintCollectionEnabled}
              />{' '}
              {updatingJournalFingerPrintMode ? (
                <Spinner className="ms-2" size="sm" />
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  );
};

export default JournalSettings;
